import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Grid, styled, Switch } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { TFormType } from 'src/@types';

import { DataMode } from './section/DataMode';
import EditorMode from './section/EditorMode';

interface IMainVisualFormDialogProps {
  formType: TFormType;
  onSubmitSuccess: () => void;
  // selectedData?: IMainVisual;
  selectedData?: any;
}

type TEditorMode = 'editor' | 'data';

export const MainVisualFormDialog = observer(
  ({ formType, onSubmitSuccess, selectedData }: IMainVisualFormDialogProps) => {
    const { t } = useTranslation();
    const [mode, setMode] = useState<TEditorMode>('data');

    // 모드 전환 핸들러
    const handleModeChange = () => {
      setMode(mode === 'data' ? 'editor' : 'data');
    };

    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          {/* TODO Editor 관련 코드 유지 */}
          {/* <ModeContainer>
            <FormControlLabel
              control={
                <ModeSwitch
                  checked={mode === 'editor'}
                  onChange={handleModeChange}
                  inputProps={{ 'aria-label': 'mode switch' }}
                />
              }
              label={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                  <Typography variant="body2" color="text.secondary">
                    {mode === 'editor'
                      ? t('mainVisual.form.mode.data')
                      : t('mainVisual.form.mode.editor')}
                  </Typography>
                  <Iconify
                    icon={mode === 'editor' ? 'mdi:form-select' : 'mdi:pencil'}
                    sx={{ width: 20, height: 20 }}
                  />
                </Box>
              }
              labelPlacement="start"
            />
          </ModeContainer> */}

          {mode === 'editor' ? (
            <EditorMode
              formType={formType}
              selectedData={selectedData}
              onSubmitSuccess={onSubmitSuccess}
            />
          ) : (
            <DataMode
              formType={formType}
              selectedData={selectedData}
              onSubmitSuccess={onSubmitSuccess}
            />
          )}
        </Grid>
      </Grid>
    );
  },
);

const ModeContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: 1,
  marginBottom: 10,
});

const ModeSwitch = styled(Switch)(({ theme }) => ({
  width: 62,
  height: 34,
  padding: 7,
  '& .MuiSwitch-switchBase': {
    margin: 1,
    padding: 0,
    transform: 'translateX(6px)',
    '&.Mui-checked': {
      color: '#fff',
      transform: 'translateX(22px)',
      '& .MuiSwitch-thumb:before': {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
          '#fff',
        )}" d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/></svg>')`,
      },
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: theme.palette.mode === 'dark' ? '#8796A5' : '#aab4be',
      },
    },
  },
  '& .MuiSwitch-thumb': {
    backgroundColor: theme.palette.mode === 'dark' ? '#003892' : '#001e3c',
    width: 32,
    height: 32,
    '&:before': {
      content: "''",
      position: 'absolute',
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        '#fff',
      )}" d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/></svg>')`,
    },
  },
  '& .MuiSwitch-track': {
    opacity: 1,
    backgroundColor: theme.palette.mode === 'dark' ? '#8796A5' : '#aab4be',
    borderRadius: 20 / 2,
  },
}));
